import { api } from "./axios";
import { getArcGISToken } from "./arcgisAuth";

// Chainage ID: 0
// Route ID: 1
// Main Road Section ID: 2
// Structure Constraint ID: 3
// Formation Widening Priorities ID: 4
export const queryLayer = async (
  layerId?: number,
  where: string = "1=1",
  baseURL?: string,
  extraParams: Record<string, any> = {}
) => {
  const token = await getArcGISToken();

  const response = await api.get(
    `/${layerId}/query`,
    {
      baseURL,
      params: {
        where,
        outFields: "*",
        f: "json",
        token,
        ...extraParams
      },
    }
  );
  return response.data;
};

export const queryDistinctValues = async (layerId: number, fieldName: string, where = "1=1") => {
  const token = await getArcGISToken();

  const response = await api.get(
    `/${layerId}/query`,
    {
      params: {
        where,
        outFields: fieldName,
        returnGeometry: false,
        groupByFieldsForStatistics: fieldName,
        outStatistics: `[{"statisticType": "count", "onStatisticField": ${fieldName}, "outStatisticFieldName": "count"}]`,
        f: "json",
        token,
      },
    }
  );
  return response.data;
};

export const queryCount = async (
  layerId: number,
  where = "1=1",
  baseURL?: string,
  extraParams: Record<string, any> = {}
) => {
  const token = await getArcGISToken();
  const response = await api.get(
    `/${layerId}/query`,
    {
      baseURL,
      params: {
        where,
        returnCountOnly: true,
        f: "json",
        token,
        ...extraParams
      },
    }
  );
  return response.data.count;
};

export const queryStatistics = async (
  layerId: number,
  statisticType: "sum" | "avg" | "min" | "max" | "percentile_disc" | "percentile_cont",
  fieldName: string,
  outStatisticFieldName: string,
  where?: "1=1",
  baseURL?: string,
  extraParams: Record<string, any> = {},
  percentileValue?: number,
) => {
  const token = await getArcGISToken();
  let outStats;
  if (percentileValue) {
    outStats = `[{"statisticType": "${statisticType}", "onStatisticField": "${fieldName}", "outStatisticFieldName": "${outStatisticFieldName}", statisticParameters: {value: ${percentileValue}} }]`
  } else {
    outStats = `[{"statisticType": "${statisticType}", "onStatisticField": "${fieldName}", "outStatisticFieldName": "${outStatisticFieldName}"}]`
  }
  const response = await api.get(
    `/${layerId}/query`,
    {
      baseURL,
      params: {
        where,
        returnGeometry: false,
        // groupByFieldsForStatistics: fieldName,
        // Note: commented this out, it works for loadLinkTotal but not for min_min_radius_M (curvature, layerid2)
        // outStatistics: `[{"statisticType": "${statisticType}", "onStatisticField": "${fieldName}", "outStatisticFieldName": "${outStatisticFieldName}"}]`,
        outStatistics: outStats,
        f: "json",
        token,
        ...extraParams
      },
    }
  );
  return response.data.features?.[0]?.attributes?.[outStatisticFieldName] ?? 0;
};
